import React from 'react';
import './FailedPayment.scss';
import { TranslationUtils, ValidationUtils } from '../../utils';
import { flowId } from '../../logging/ddLogger';
import { AdjustmentPolicies } from 'guest-data-types-ts-lib';

export interface FailedPaymentProps {
    adjustment?: AdjustmentPolicies | null;
}

export const FailedPayment: React.FC<FailedPaymentProps> = (props: FailedPaymentProps) => {
    let tollFreePhone = ValidationUtils.validateAndGetEnvVar('REACT_APP_TOLL_FREE_PHONE_NUMBER');
    const { adjustment } = props;

    const phone = (
        <strong>
            <span>
                <a href={`tel:${tollFreePhone}`}>{tollFreePhone}</a>
            </span>
        </strong>
    );
    return (
        <div className="failed-adjustment-modal">
            <div tabIndex={0} className="failed-payment-header">
                {!adjustment && <h1 className="page-subtitle">{TranslationUtils.get('payment_failed')}</h1>}
                {adjustment && <h1 className="page-subtitle">{TranslationUtils.get('adjustment_failed_title')}</h1>}
            </div>
            <div className={'failed-modal-note'}>
                {adjustment === 'addNight' && <p tabIndex={0}>{TranslationUtils.get('payment_call_us_to_complete')}</p>}

                {!adjustment && <p tabIndex={0}>{TranslationUtils.get('pay_balance_issue', { phone })}</p>}

                {adjustment && (
                    <p tabIndex={0}>
                        {`${TranslationUtils.get('payment_call_us_to_complete_start')} `}
                        {phone}
                        {` ${TranslationUtils.get('payment_call_us_to_complete_end')}`}
                    </p>
                )}
            </div>
            <span className="error-flow-id text-muted">ref: {flowId}</span>
        </div>
    );
};
